import Link from "next/link";
import ArrowIcon from "../ArrowIcon";
import style from "./ArrowLink.module.css";
import ArrowLinkProps from "./types";
const ArrowLink = ({
  label,
  direction = "right",
  href,
  fullwidth,
  border = "top",
}: ArrowLinkProps) => {
  const content = (
    <>
      <span className={`${style.label}`}>{label}</span>
      <span className={style.arrow}>
        {direction === "right" ? (
          <ArrowIcon />
        ) : direction === "left" ? (
          "←"
        ) : direction === "down" ? (
          "↓"
        ) : direction === "up" ? (
          "↑"
        ) : (
          ""
        )}
      </span>
    </>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={`${style.arrowLink} ${fullwidth ? style.fullwidth : ""}  ${style[border]}`}
      >
        {content}
      </Link>
    );
  }
  return (
    <span
      className={`${style.arrowLink} ${fullwidth ? style.fullwidth : ""}  ${style[border]}`}
    >
      {content}
    </span>
  );
};
export default ArrowLink;
